import { Permission } from '@cims-online/shared'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreEjTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { EJType, useTypesTableContext } from '../../../../TypesTableContext'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'

export function useRestore(): RestoreRowActionOptions<EJType> {
  const { refetch } = useTypesTableContext()
  const [restore] = useRestoreEjTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreEJType: {
        type: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreEJType,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
